module.exports = __webpack_public_path__ + "img/Nas.e946d478.svg";